import { Link } from 'react-router-dom';
import NumberFormat from "react-number-format";

import moment from 'moment';
import { useSelector } from 'react-redux';

export const InvoiceList = ({ list }) => {

    const {
        // id: pptoId,
        id_moneda,
        valor_tipo_cambio,
        simbolo,
        separacion_miles,
        separacion_decimales
    } = useSelector(state => state.ppto.detail)

    const onClickDetail = (item) => {
        let detail = item;
        detail.items = [];
    }

    return (
        <div className='p-pptos mt-2'>
            <div className='row'>

                <div className='col'>

                    {list?.length > 0 ?
                        <div className="table-responsive">
                            <table className="table p-table-global">
                                <thead className='p-thead-global'>
                                    <tr className="text-center p-tr-titles-global">
                                        <th className='text-start'>Número</th>
                                        <th scope="col">Estado</th>
                                        <th scope="col">Fecha emisión</th>
                                        <th scope="col" className='text-start'>Cliente</th>
                                        <th scope="col" className='text-start'>Descripción factura</th>
                                        <th scope="col" className='text-end'>Monto Base</th>
                                        <th scope="col" className='text-end'>Impuesto</th>
                                        <th scope="col" className='text-end'>Total Factura</th>
                                        <th scope="col" className='text-end'>Cobrado</th>
                                        <th scope="col" className='text-end'>Por cobrar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list?.map(item => (
                                        <tr key={item.id} onClick={() => onClickDetail(item)} className="p-tr-body-global">
                                            <td className="text-center" >
                                                <Link className='LinkTable flex flex-col items-start justify-center' to={`/facturas/${item.id}`}>
                                                    <span>{item.numero ? item.numero : 'S/N'}</span>
                                                    <span className='text-[10px]'>{item.nombre_tipo_documento}</span>
                                                </Link>
                                            </td>
                                            <td className="text-center">
                                                <Link className='LinkTable' to={`/facturas/${item.id}`}>
                                                    {item.estado || 'por emitir'}
                                                </Link>
                                            </td>
                                            <td className="text-center" >
                                                <Link className='LinkTable' to={`/facturas/${item.id}`}>
                                                    {moment(item.fecha_emision).format('DD-MM-YYYY') || 'ninguno'}
                                                </Link>
                                            </td>
                                            <td className="text-start">
                                                <Link className='LinkTable' to={`/facturas/${item.id}`}>
                                                    {item.razon_social || 'ninguno'}
                                                </Link>
                                            </td>
                                            <td className="text-start">
                                                <Link className='LinkTable' to={`/facturas/${item.id}`} >
                                                    <p>{item.referencia || 'ninguno'}</p>
                                                </Link>
                                            </td>
                                            <td className="text-end">
                                                <Link className='LinkTable d-flex flex-column' to={`/facturas/${item.id}`} >
                                                    <NumberFormat
                                                        value={item.monto_base ? parseFloat(item.monto_base) : 0}
                                                        displayType={'text'}
                                                        thousandSeparator={item.separacion_miles}
                                                        decimalSeparator={item.separacion_decimales}
                                                        prefix={`${item.simbolo} `}
                                                        decimalScale={2}
                                                        fixedDecimalScale
                                                    />

                                                    {(parseInt(id_moneda) === 4 && parseInt(item.id_moneda) !== 4) ?
                                                        <NumberFormat
                                                            value={(item.monto_base ? parseFloat(item.monto_base) : 0) / parseFloat(valor_tipo_cambio || 1)}
                                                            displayType={'text'}
                                                            thousandSeparator={separacion_miles}
                                                            decimalSeparator={separacion_decimales}
                                                            prefix={`${simbolo} `}
                                                            decimalScale={2}
                                                            fixedDecimalScale
                                                        /> : ''
                                                    }

                                                </Link>
                                            </td>
                                            <td className="text-end">
                                                <Link className='LinkTable' to={`/facturas/${item.id}`} >
                                                    <NumberFormat
                                                        value={item.total_impuesto ? parseFloat(item.total_impuesto) : 0}
                                                        displayType={'text'}
                                                        thousandSeparator={item.separacion_miles}
                                                        decimalSeparator={item.separacion_decimales}
                                                        prefix={`${item.simbolo} `}
                                                        decimalScale={2}
                                                        fixedDecimalScale
                                                    />
                                                </Link>
                                            </td>
                                            <td className="text-end">
                                                <Link className='LinkTable' to={`/facturas/${item.id}`} >
                                                    <NumberFormat
                                                        value={item.total_factura ? parseFloat(item.total_factura) : 0}
                                                        displayType={'text'}
                                                        thousandSeparator={item.separacion_miles}
                                                        decimalSeparator={item.separacion_decimales}
                                                        prefix={`${item.simbolo} `}
                                                        decimalScale={2}
                                                        fixedDecimalScale
                                                    />
                                                </Link>
                                            </td>
                                            <td className="text-end">
                                                <Link className='LinkTable' to={`/facturas/${item.id}`} >
                                                    <NumberFormat
                                                        value={item.total_cobrado ? parseFloat(item.total_cobrado) : 0}
                                                        displayType={'text'}
                                                        thousandSeparator={item.separacion_miles}
                                                        decimalSeparator={item.separacion_decimales}
                                                        prefix={`${item.simbolo} `}
                                                        decimalScale={2}
                                                        fixedDecimalScale
                                                    />
                                                </Link>
                                            </td>
                                            <td className="text-end">
                                                <Link className='LinkTable' to={`/facturas/${item.id}`} style={{ position: 'relative' }}>
                                                    <NumberFormat
                                                        value={item.total_por_cobrar ? parseFloat(item.total_por_cobrar) : 0}
                                                        displayType={'text'}
                                                        thousandSeparator={item.separacion_miles}
                                                        decimalSeparator={item.separacion_decimales}
                                                        prefix={`${item.simbolo} `}
                                                        decimalScale={2}
                                                        fixedDecimalScale
                                                    />

                                                    {(
                                                        item.aplica_detraccion &&
                                                        (parseFloat(item.total_por_cobrar) === parseFloat(item.total_detraccion))
                                                    ) ?
                                                        <span
                                                            style={{
                                                                position: 'absolute',
                                                                marginBottom: 0,
                                                                fontSize: '9px',
                                                                top: '18px',
                                                                right: '0px',
                                                                color: '#8E24AA',
                                                                backgroundColor: '#FCF1FF',
                                                                padding: '0px 2px',
                                                                borderRadius: '3px',
                                                                width: '85px'
                                                            }}
                                                        >detracción{' '}{parseFloat(item.porcentaje_detraccion)}%</span> : ''
                                                    }

                                                </Link>
                                            </td>
                                        </tr>
                                    ))
                                    }
                                </tbody>
                            </table>

                        </div>
                        :
                        <h2 className='text-[16px] mt-2'>No hay facturas asociadas.</h2>
                    }

                </div>

            </div>
        </div>
    )
}